export enum AccountButtonEnum {
  'Profile' = 'Profile',
  'Integration' = 'Integration',
}

export const AccountButtons = Object.values(AccountButtonEnum);
